import type { ClientType, LegalType } from '@shared/documents'
import type { ChangeEvent } from 'react'
import type { ApiSupplier } from '@/fetcher'
import { PassportOcrSections } from './PassportOcrSections'
import { SectionCard } from './SectionCard'

type IntroStepSectionsProps = {
  clientType: ClientType
  legalType: LegalType
  isUploadingPassport: boolean
  isMainPassportLoading: boolean
  isRegistrationLoading: boolean
  isSuppliersLoading: boolean
  suppliers: ApiSupplier[]
  selectedSupplierId: string
  onMainFileChange: (event: ChangeEvent<HTMLInputElement>) => void
  onRegistrationFileChange: (event: ChangeEvent<HTMLInputElement>) => void
  onClientTypeChange: (clientType: ClientType) => void
  onLegalTypeChange: (legalType: LegalType) => void
  onOpenSuppliers: () => void
}

export const IntroStepSections = ({
  clientType,
  legalType,
  isUploadingPassport,
  isMainPassportLoading,
  isRegistrationLoading,
  isSuppliersLoading,
  suppliers,
  selectedSupplierId,
  onMainFileChange,
  onRegistrationFileChange,
  onClientTypeChange,
  onLegalTypeChange,
  onOpenSuppliers,
}: IntroStepSectionsProps) => {
  const selectedSupplier = suppliers.find(
    (supplier) => supplier.id === selectedSupplierId,
  )

  const selectorLabel = isSuppliersLoading
    ? 'Загрузка поставщиков...'
    : selectedSupplier
      ? selectedSupplier.name
      : suppliers.length > 0
        ? 'Выберите поставщика'
        : 'Поставщики не добавлены'

  return (
    <>
      <SectionCard title="Поставщик">
        <div className="space-y-2">
          <label
            className="block text-sm font-medium text-[var(--app-text)]"
            htmlFor="supplier-preset"
          >
            Выберите поставщика для авто-подстановки
          </label>

          <div className="relative">
            <button
              type="button"
              id="supplier-preset"
              className="w-full appearance-none rounded-[22px] bg-[var(--app-input)] px-4 py-3 pr-12 text-left text-sm leading-6 outline-none transition focus:ring-4 focus:ring-[var(--app-accent-soft)]"
              disabled={isSuppliersLoading}
              onClick={onOpenSuppliers}
            >
              <span
                className={
                  selectedSupplier
                    ? 'text-[var(--app-text)]'
                    : 'text-[var(--app-muted)]'
                }
              >
                {selectorLabel}
              </span>
            </button>

            <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-[var(--app-muted)]">
              ↓
            </span>
          </div>
        </div>

        {selectedSupplier?.description ? (
          <p className="text-sm leading-6 text-[var(--app-muted)]">
            {selectedSupplier.description}
          </p>
        ) : null}
      </SectionCard>

      <PassportOcrSections
        clientType={clientType}
        legalType={legalType}
        isUploadingPassport={isUploadingPassport}
        isMainPassportLoading={isMainPassportLoading}
        isRegistrationLoading={isRegistrationLoading}
        onMainFileChange={onMainFileChange}
        onRegistrationFileChange={onRegistrationFileChange}
        onClientTypeChange={onClientTypeChange}
        onLegalTypeChange={onLegalTypeChange}
      />
    </>
  )
}
